import React from 'react'
import styles from './styles.module.css'
function CommonLayout({children}) {
  return (
    <section className={styles.container}>
      <div className={styles.fixedBackground}></div>
        {children}
    </section>
  )
}

export default CommonLayout